import { render, staticRenderFns } from "./viewmedical_certificate.vue?vue&type=template&id=16982fbf&"
import script from "./viewmedical_certificate.vue?vue&type=script&lang=js&"
export * from "./viewmedical_certificate.vue?vue&type=script&lang=js&"
import style0 from "./viewmedical_certificate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports